import {useMutation, useQueryClient} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {errorHandler} from '@utilities/helpers.ts'
import {httpHostResponsive} from '@features/assignment/http/assignment.http'
import {Assignment} from '@features/assignment/types.ts'
import {captureException} from '@sentry/react'
import {parseAxiosPromise} from '@/axiosInstance.ts'

export const useHostResponsive = ({assignmentId, taskId}: {assignmentId: number; taskId: number}) => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: () =>
            parseAxiosPromise({
                axiosPromise: httpHostResponsive({
                    urlParams: {assignmentId, taskId},
                    params: {response_type: 'extended'}
                }),
                responseShape: Assignment,
                onZodError: captureException
            }),
        onError: errorHandler,
        onSuccess: data => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.CURRENT_ASSIGNMENTS]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ACTIVE_ASSIGNMENTS_RANGE]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ACTIVE_ASSIGNMENTS_TABLE]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ASSIGNMENTS_COUNT]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ASSIGNMENTS]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.HOME_TABLE]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.REQUIRED_ACTIONS]})
            void queryClient.setQueriesData({queryKey: [QUERY_KEYS.ASSIGNMENT, data.code]}, data)
        }
    })
}
